module.exports = require('./helpers/bundle-url').getBundleURL('QXyrT') + "logo.2d36f6c0.png";